exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".state-switch[data-v-0b4491cc]:hover {\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.overflowing[data-v-0b4491cc] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 125px;\n  cursor: help;\n}\n.coef-price[data-v-0b4491cc] {\n  white-space: nowrap;\n  overflow: visible;\n}\n.no-wrap[data-v-0b4491cc] {\n  white-space: nowrap;\n}\n", ""]);

// exports
